import { Component, OnInit, HostListener } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';
import { filter } from 'rxjs/operators';
import { Router, NavigationEnd } from '@angular/router';

import { REQUEST_STEPS } from './enum-request-steps';
import {
  CAR_TYPE,
  MarketPlaceQuoteRequestService,
} from 'src/app/services/market-place-quote-request-service/market-place-quote-request.service';
import { filterSelectionState } from '../../search-cars-component/search-cars.helper.consts';

@Component({
  selector: 'app-request-quote',
  templateUrl: './request-quote.component.html',
  styleUrls: ['./request-quote.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class RequestQuoteComponent implements OnInit {
  request_steps_enums = REQUEST_STEPS;
  currentStep: REQUEST_STEPS = this.quoteRequestService.getCurrenStep();
  selectedCarType: any;
  enum_car_type = CAR_TYPE;

  constructor(
    private quoteRequestService: MarketPlaceQuoteRequestService,
    private router: Router
  ) {
    this.router.events
      .pipe(filter((rs): rs is NavigationEnd => rs instanceof NavigationEnd))
      .subscribe((event) => {
        if (event.id === 1 && event.url === event.urlAfterRedirects) {
          this.router.navigate(['/search-inventory'], {
            state: { refresh: true },
          });
        }
      });
    this.selectedCarType = this.quoteRequestService.getSelectedCarType();
  }

  @HostListener('window:beforeunload', ['$event']) beforeUnloadHander(
    event: any
  ) {
    if (event != null && event.currentTarget != null) {
      const path = event.currentTarget.location.pathname;
      if (path.includes('/request-quote')) {
        const dialogText = 'Are you sure you want to exit this page?';
        event.returnValue = dialogText;
      }
    }
  }

  @HostListener('window:unload', ['$event']) unloadHandler(event: any) {
    window.scrollTo(0, 0);

    const StccObj = this.quoteRequestService.getDefaultStcc();
    const ProductName = this.quoteRequestService.getProductName();
    const CarType = this.quoteRequestService.getSelectedCarType();

    const data = { StccObj, CarType, ProductName };

    sessionStorage.setItem(filterSelectionState, JSON.stringify(data));
  }

  ngOnInit(): void {
    this.quoteRequestService.nextStep$.subscribe((value) => {
      this.currentStep = value;
    });
    history.replaceState(
      null,
      '',
      window.location.origin + '/search-inventory/'
    );
  }
}
